import React, { lazy, Suspense } from 'react';
import './App.css';
import {BrowserRouter, Routes, Route, Navigate  } from 'react-router-dom';
import axios from './axios';
import ProtectedRoute from './components/ProtectedRoute';
import { HelmetProvider } from 'react-helmet-async';

//componenty niechronione
import MainPage from './components/Home/MainPage/MainPage';
import LoginPage from './components/LoginPage/LoginPage';
import RegisterPage from './components/Home/RegisterPage/RegisterPage';
import logo from './img/nekrodruk-logo-dark.png';
import { AuthProvider } from './context/AuthContext';
import DefaultLayout from './components/DefaultLayout';
import CustomizationAdvanced from './components/HomeLogged/CustomizationAdvanced/CustomizationAdvanced';
import AccountEmployee from './components/HomeLogged/Account/AccountEmployee';
import Demo from './components/Home/Demo/Demo';
import DataReceiver from './components/Home/DataReceiver/DataReceiver';
import CoToNekrolog from './components/Home/CoToNekrolog/CoToNekrolog';
import SubscriptionExpired from './components/SubscriptionExpired/SubscriptionExpired';


//komponenty chronione dla usera
const PersonForm = lazy(() => import('./components/HomeLogged/PersonForm/PersonForm'));
const Quotes = lazy(() => import('./components/HomeLogged/Quotes/Quotes'));
const Definitions = lazy(() => import('./components/HomeLogged/Definitions/Definitions'));
const MassPlaces = lazy(() => import('./components/HomeLogged/MassPlaces/MassPlaces'));
const FuneralPlaces = lazy(() => import('./components/HomeLogged/FuneralPlaces/FuneralPlaces'));
const FamilyMembers = lazy(() => import('./components/HomeLogged/FamilyMembers/FamilyMembers'));
const Account = lazy(() => import('./components/HomeLogged/Account/Account'));
const XMLGenerator = lazy(() => import('./components/HomeLogged/layouts/XMLGenerator/XMLGenerator'));
const Templates = lazy(() => import('./components/HomeLogged/Templates/Templates'));
const Sash = lazy(() => import('./components/HomeLogged/layouts/Sash/Sash'));
const Customization = lazy(() => import('./components/HomeLogged/Customization/Customization'));
const ConsentsGate = lazy(() => import('./components/ConsentsGate/ConsentsGate'));
const Subscription = lazy(() => import('./components/HomeLogged/Subscription/Subscription'));

// import AdminPanel from './components/AdminPanel/AdminPanel';
const AdminPanel = lazy(() => import('./components/AdminPanel/AdminPanel'));


export default function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={
                <section className='loading_section'>
                    <img src={logo} alt='loading_logo' className='loading_logo'/>
                <span className="loader"></span>
                </section>
            }>
          <Routes>
          <Route element={<DefaultLayout />}>
              <Route path="*" element={<Navigate to="/" replace />} />

              <Route path="/" element={<MainPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/co-to-nekrolog" element={<CoToNekrolog />} />
              <Route path="/subscription-expired" element={<SubscriptionExpired />} />
              <Route path="/receive-data" element={<DataReceiver />} />

              <Route path="/admin" element={<ProtectedRoute element = {AdminPanel} adminOnly = {true} />} />

              <Route path="/consents" element={<ProtectedRoute element = {ConsentsGate} allowWithoutConsent />} />

              <Route path="/personForm" element={<ProtectedRoute element = {PersonForm}/>} />
              <Route path="/quotes" element={<ProtectedRoute element = {Quotes} />}/>
              <Route path="/definitions" element={<ProtectedRoute element = {Definitions} />}/>
              <Route path="/massplaces" element={<ProtectedRoute element = {MassPlaces} />} />
              <Route path="/funeralplaces" element={<ProtectedRoute element = {FuneralPlaces} />} />
              <Route path="/familymembers" element={<ProtectedRoute element = {FamilyMembers} />} />
              <Route path="/account" element={<ProtectedRoute element = {Account} />} />
              <Route path="/accountemployee" element={<ProtectedRoute element = {AccountEmployee} />} />
              <Route path="/subscription" element={<ProtectedRoute element = {Subscription} allowWithoutSubscription />} />
              <Route path="/sash" element={<ProtectedRoute element = {Sash} />} />
              <Route path="/XMLGenerator" element={<ProtectedRoute element = {XMLGenerator} />} />
              <Route path="/templates" element={<ProtectedRoute element = {Templates} />} />
              <Route path="/customization" element={<ProtectedRoute element = {Customization} />} />
              <Route path="/advanced-customization" element={<ProtectedRoute element = {CustomizationAdvanced} />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}
